import { Result, validatedApiCall } from '../api';
import { APIValidationError } from '../../types/api/api';
import { UUID } from '../../types/standard';

export const deleteMiembro = async (
  id: UUID | undefined,
): Promise<Result<boolean, APIValidationError>> => {
  return validatedApiCall<boolean>(`/api/miembros/${id}`, {
    method: 'DELETE',
    auth: true,
  });
};
